import React from 'react';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import {apiIdToIconName} from 'util/APIUtil';

import {BulkChipItemPrefetchQuery} from './__generated/BulkChipItemPrefetchQuery';
import SmartChip from './SmartChip';
import useSmartChipQuery, {SmartChipType} from './useSmartChipQuery';

type ChipWorksheet = ExtractByTypename<BulkChipItemPrefetchQuery['worksheets'][number], 'WorksheetNode'>;

function getSecondaryText(worksheet: ChipWorksheet): string | null {
  return worksheet.displayId;
}

export default function WorksheetChip(props: SharedSmartChipProps<SmartChipType.WORKSHEET>): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: worksheet,
    handleClickLink,
    isInaccessible,
    itemUrl: worksheetUrl,
  } = useSmartChipQuery<SmartChipType.WORKSHEET>({
    id,
    onClick,
    getUrlFn: ({editUrl}) => editUrl,
  });

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={worksheet != null ? apiIdToIconName(worksheet.id) : null}
      isInaccessible={isInaccessible}
      item={worksheet}
      onClick={handleClickLink}
      url={worksheetUrl}
      getSecondaryText={getSecondaryText}
    />
  );
}
